import { Link, useLocation } from 'react-router-dom';
import { FolderOpen, Upload, Share2, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { clsx } from 'clsx';

export function Navigation() {
  const { token, logout } = useAuth();
  const location = useLocation();

  const navigation = [
    { name: '我的文件', href: '/', icon: FolderOpen },
    { name: '分享管理', href: '/shares', icon: Share2 },
    { name: '系统设置', href: '/settings', icon: Settings },
  ];

  return (
    <nav className="glass-panel flex w-full flex-col gap-4 rounded-3xl p-6 text-white lg:w-72">
      <div className="space-y-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={clsx(
                'flex items-center gap-3 rounded-2xl px-4 py-3 text-sm transition',
                isActive
                  ? 'bg-white/10 text-white shadow-inner shadow-black/40'
                  : 'text-white/60 hover:bg-white/5 hover:text-white',
              )}
            >
              <item.icon className="h-4 w-4" />
              {item.name}
            </Link>
          );
        })}
      </div>

      <div className="mt-auto">
        <button
          onClick={logout}
          className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 text-sm text-red-400 transition hover:bg-red-500/10 hover:text-red-300"
        >
          <LogOut className="h-4 w-4" />
          退出登录
        </button>
      </div>
    </nav>
  );
}